import { SvgIcon } from '@material-ui/core';

export const MovieIcon: typeof SvgIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25">
      <path
        d="M4 2c-1.105 0-2 .9-2 2v17c0 1.1.895 2 2 2h16c1.105 0 2-.9 2-2V4c0-1.1-.895-2-2-2H4z"
        fill="#2c3e50"
      />
      <path fill="#16a085" d="M6 16h12v6H6zM6 1h12v7H6z" />
      <path fill="#1abc9c" d="M6 7h12v10H6z" />
      <path
        d="M4 1c-1.105 0-2 .9-2 2v17c0 1.1.895 2 2 2h2V1H4zM20 1c1.105 0 2 .9 2 2v17c0 1.1-.895 2-2 2h-2V1h2z"
        fill="#34495e"
      />
      <path
        d="M3.5 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zM19.5 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1zm0 3c-.276 0-.5.2-.5.5v1c0 .2.224.5.5.5h1c.276 0 .5-.3.5-.5v-1c0-.3-.224-.5-.5-.5h-1z"
        fill="#16a085"
      />
      <path d="m10 14.936.096-6L15 12.023z" fill="#ecf0f1" />
    </SvgIcon>
  );
};
